type JwtPayload = {
  exp?: number;
  [key: string]: unknown;
};

export const decodeJwt = (token: string): JwtPayload | null => {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const data = decodeJwt(token);
  if (!data || !data.exp) return true;

  const now = Math.floor(Date.now() / 1000);
  return data.exp < now;
};
